import React, { useMemo } from 'react';
import Data from '../../../components/Backoffice/Display/Data';
import Section from '../../../components/Backoffice/Display/Section';
import moment from 'moment';
import { formatDate } from '../../../utils/stringHelper';

function ResidencyAccount({
  account,
  handleCreateAccount,
  handleDeleteAccount,
  handleCopyAccountToken,
  loading
}) {
  const createAccountActions = useMemo(() => {
    const actions = [];
    if (account) {
      if (!account.last_signin_dt) {
        actions.push({
          onClick: handleCopyAccountToken,
          label: 'Copier le lien de 1ère connexion',
          icon: 'pi-copy',
          loading
        });
      }
      actions.push({
        onClick: handleDeleteAccount,
        label: 'Supprimer le compte',
        severity: 'danger',
        icon: 'pi-trash',
        loading
      });
    } else {
      actions.push({
        onClick: handleCreateAccount,
        label: 'Créer un compte utilisateur',
        icon: 'pi-plus',
        loading
      });
    }
    return actions;
  }, [account]);

  return (
    <Section label="Compte utilisateur" actions={createAccountActions}>
      {account ? (
        <div className="data-section-row">
          <Data key="email" label={'Email'} value={account.email} large />
          <Data
            key="creation_dt"
            label={'Création du compte'}
            value={formatDate(account.creation_date)}
            large
          />
          <Data
            key="last_signin"
            label={'Dernière connexion'}
            value={account.last_signin_dt ? moment(account.last_signin_dt).fromNow() : 'Jamais'}
            large
            prefixBadgeSeverity={account.last_signin_dt ? 'success' : 'danger'}
          />
        </div>
      ) : (
        <span className="text-slate-400 italic font-extralight">Pas de compte utilisateur</span>
      )}
    </Section>
  );
}

export default ResidencyAccount;
